<template>
    <v-app>
      <v-main>
            <v-container class="fill-height" fluid >
                <v-row align="center" justify="center" no-gutters>
                    <v-col cols="12" class="text-center d-flex align-center justify-center">
                        <div class="mb-10">
                          <b>Guten Tag Tourismusverband Vogtland e.V.,</b><br><br> 
                          bitte scannen Sie diesen Link und rufen Sie danach die entsprechende Website auf.<br> 
                          Wir haben versucht, die gestrige Idee der Informationsnutzung eines QR Codes zu visualisieren.<br> 
                          Bitte haben Sie Verständnis dafür, dass nicht alle Features dieses Tests bis ins kleinste Detail <br> 
                          mit Inhalt und Funktionalität hinterlegt worden sind. Alle wichtigen Dinge sind etabliert.<br> <br> 

                          Mit dieser Anwendung können detailierte Messungen (Klicks) aufgezeichnet und ausgewertet werden.<br> <br> 

                          <b>Wichtig!</b> Dieser QR Code simbolisiert einen x - beliebigen Kunden in Ihrem Vogtland Journal.<br>
                          Die unisigns GmbH und Ihre Daten stehen stellvertretend für diesen Kunden.
                        </div>
                    </v-col>
                    <v-col class="text-center d-flex align-center justify-center">
                        <div>
                          <v-img :src="require('@/assets/frame.png?webp')" style="height:200px;width:200px;" :aspect-ratio="1/1"></v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" class="text-center d-flex align-center justify-center">
                        <div class="mt-10">
                          Sollte die unisigns GmbH den Zuschlag für das Projekt "Vogtland Journal" bekommen,<br>
                          würden wir gerne diese kleine Anwendung skalieren und dynamisch erweitern,<br>
                          selbstverständlich nach Ihren Design Vorgaben.<br><br>

                          <b>Beste Grüße, das Team der unisigns GmbH</b>
                        </div>
                    </v-col>
                </v-row>    
            </v-container>
      </v-main>
    </v-app>
</template>

<script>


export default {


};
</script>
